import Router from "./Routes";

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
